import { z } from "zod";

export const workbookEditSchema = z.object({
  sheet: z.string().min(1).max(31),
  address: z.string().regex(/^[A-Z]{1,3}[1-9]\d{0,4}$/),
  value: z.union([z.string().max(4000), z.number().finite(), z.boolean(), z.null()]),
});
export const workbookEditsSchema = z.array(workbookEditSchema).max(500);
export type WorkbookEdit = z.infer<typeof workbookEditSchema>;

const cellSchema = z.object({
  address: z.string(), column: z.number().int(), style: z.number().int(),
  text: z.string(), value: z.union([z.string(), z.number(), z.boolean(), z.null()]),
  kind: z.enum(["text", "number", "date", "boolean", "error"]),
  formula: z.string().nullable(), rowSpan: z.number().int(), colSpan: z.number().int(),
  editable: z.boolean(),
  runs: z.array(z.object({ text: z.string(), style: z.number().int() })).optional(),
});
const styleSchema = z.object({
  fontFamily: z.string().optional(), fontSize: z.string().optional(), fontWeight: z.enum(["400", "700"]).optional(),
  fontStyle: z.enum(["italic", "normal"]).optional(), textDecoration: z.string().optional(), color: z.string().optional(),
  backgroundColor: z.string().optional(), textAlign: z.enum(["left", "right", "center", "justify", "start", "end"]).optional(),
  verticalAlign: z.enum(["top", "middle", "bottom"]).optional(), whiteSpace: z.enum(["pre", "pre-wrap"]).optional(),
  borderTop: z.string().optional(), borderBottom: z.string().optional(), borderLeft: z.string().optional(), borderRight: z.string().optional(), paddingLeft: z.string().optional(),
});
export const planWorkbookSchema = z.object({
  fingerprint: z.string().regex(/^[a-f0-9]{64}$/), fileName: z.string(), preferredSheet: z.string(),
  styles: z.array(styleSchema),
  sheets: z.array(z.object({
    name: z.string(),
    columns: z.array(z.object({ number: z.number().int(), letter: z.string(), width: z.number() })),
    rows: z.array(z.object({ number: z.number().int(), height: z.number(), cells: z.array(cellSchema) })),
  })),
});
export const planWorkbookResponseSchema = z.object({ workbook: planWorkbookSchema, fileBase64: z.string() });
export type PlanWorkbook = z.infer<typeof planWorkbookSchema>;
export type WorkbookCell = z.infer<typeof cellSchema>;
export type WorkbookStyle = PlanWorkbook["styles"][number];
